export default function NotFound() {
  return (
    <div style={{
      minHeight: "60vh",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
      padding: "2rem"
    }}>
      <h1 style={{ fontSize: "4rem", fontWeight: "700", color: "#1f2937", marginBottom: "1rem" }}>
        404
      </h1>
      <p style={{ fontSize: "1.25rem", color: "#6b7280", marginBottom: "2rem" }}>
        Pagina nao encontrada
      </p>
      <a 
        href="/"
        style={{
          padding: "0.75rem 1.5rem",
          backgroundColor: "#a4133c",
          color: "#fff",
          borderRadius: "8px",
          textDecoration: "none"
        }}
      >
        Voltar para o inicio
      </a>
    </div>
  );
}
